<script>
// `~/stores/dynamic-input-store` + `@/stores/collaborator-store` live
// outside the editor directory tree. Canvas preview only needs the
// button to render — real submit round-trips happen on the FanWeb
// side.
import { ApplyToCollaboratePageElementMixin }
  from "%/dynamic-component-editor/standard-pages/apply-to-collaborate-page/apply-to-collaborate-page-element-mixin";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";

export default {
  name: "ApplyToCollaborateButton",
  elementPanelSettings: {
    displayName: "Apply Button",
    displayIcon: "button",
    elementType: "element",
    elementGroup: "applyToCollaborateElements",
  },
  extends: BaseButtonElement,
  mixins: [ApplyToCollaboratePageElementMixin],
  optionBundles: [
    new ButtonOptions({
      "default.text-option": "Apply",
    }, {
      "button-action": true,
      "link-type": true,
      "href-option": true,
    }),
  ],
  computed: {
    isCreatingApplication() {
      return false;
    },
  },
  methods: {
    handleButtonClick() {
      // No-op in Studio canvas preview.
    },
  },
};
</script>

<style scoped lang="scss">
</style>
